import React from 'react';
import { Button, Image, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const CTADoubleLink = ({ CTAparagraph }) => {
  const CTAtitle = CTAparagraph.entity.field_title[0].value;
  const CTABody = CTAparagraph.entity.field_body[0].value;
  const CTALink = CTAparagraph.entity.field_link[0].alias ?? CTAparagraph.entity.field_link[0].uri;
  const CTALinkTitle = CTAparagraph.entity.field_link[0].title;
  const CTALinkTarget = CTAparagraph.entity.field_link[0].options?.attributes?.target || '_self';
  const CTASecondaryLink = CTAparagraph.entity.field_link_secondary[0]?.alias ?? CTAparagraph.entity.field_link_secondary[0]?.uri;
  const CTASecondaryLinkTitle = CTAparagraph.entity.field_link_secondary[0]?.title;
  const CTASeconcaryLinkTarget = CTAparagraph.entity.field_link_secondary[0]?.options?.attributes?.target || '_self';

  const CTAImageStyles = CTAparagraph.entity.field_media_item[0]?.styles;

  return (
    <div className="CTADoubleLink">
      <div className="CTADoubleLink__content">
        {CTAImageStyles && (
          <div className="CTADoubleLink__image">
            <Image
              src={CTAImageStyles['16_9_medium']}
            />
          </div>
        )}
        <h3 className="CTADoubleLink__title">{CTAtitle}</h3>

        <WysiwygField
          property="schema:text"
          className="CTADoubleLink__body"
          html={CTABody}
        />

        <div className="CTADoubleLink__buttonWrapper">
          <Button
            className="Button--cta"
            href={CTALink}
            target={CTALinkTarget}
            primary={false}
          >
            {CTALinkTitle}
          </Button>

          {(CTASecondaryLink && CTASecondaryLinkTitle) && (
            <Button
              className="CTADoubleLink__buttonWrapper__link"
              href={CTASecondaryLink}
              primary={false}
              target={CTASeconcaryLinkTarget}
            >
              {CTASecondaryLinkTitle}
              <i className="icon icon-arrow-right icon-variant-2" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CTADoubleLink;
